import signHero from "../assets/sign.png";
import product1 from "../assets/product1.png";
import product2 from "../assets/product2.png";
import product3 from "../assets/product3.png";
import product4 from "../assets/product4.png";
import product5 from "../assets/product5.png";
import product6 from "../assets/product6.png";
import product7 from "../assets/product7.png";
import product8 from "../assets/product8.png";
import product9 from "../assets/product9.png";
import product10 from "../assets/product10.png";
import product11 from "../assets/product11.png";
import product12 from "../assets/product12.png";
import product13 from "../assets/product13.png";
import product14 from "../assets/product14.png";
import product15 from "../assets/product15.png";
import product16 from "../assets/product16.png";
import product17 from "../assets/product17.png";
import product18 from "../assets/product18.png";

const CONTACT_MAILTO =
  "mailto:sunil@signandgraphics.me?subject=Sign%20%26%20Graphics%20Enquiry&body=Hello%20Team,%0A%0AI%20would%20like%20to%20enquire%20about%20your%20Sign%20%26%20Graphics%20services.%0A%0ACompany%20Name:%0AContact%20Number:%0AProject%20Details:%0A";

const portfolioFallbacks = [
  product1,
  product2,
  product3,
  product4,
  product5,
  product6,
  product7,
  product8,
  product9,
  product10,
  product11,
  product12,
  product13,
  product14,
  product15,
  product16,
  product17,
  product18,
];

/** Bundled fallbacks when CMS image fields are empty */
export const SIGN_FALLBACKS = {
  hero: {
    backgroundImage: signHero,
    badge: "Creative Branding Solutions",
    title: "SIGN AND GRAPHICS",
    subtitle:
      "Professional signage, acrylic fabrication, exhibition displays, and visual branding solutions for businesses, events, and retail spaces.",
    primaryButtonText: "Contact Us",
    primaryButtonLink: CONTACT_MAILTO,
    secondaryButtonText: "View Services",
    secondaryButtonLink: "#sign-services",
  },
  about: {
    label: "About Us",
    title: "Complete Advertising & Fabrication Solutions",
    paragraphs: [
      "SG Sign and Graphics is a group venture specialized in material supply, fabrication, and implementation for the advertising industry.",
      "Our experienced team plans, assists, recommends, and implements the right solutions for exhibitions, retail displays, corporate branding, signage, and promotional projects.",
    ],
    cardTitle: "What We Deliver",
    cardDescription:
      "From concept to installation, we help brands create strong visual experiences through quality materials and creative execution.",
  },
  services: {
    subtitle: "Our Services",
    title: "Branding, Display & Fabrication Services",
    description:
      "Explore our range of signage, acrylic, exhibition, and promotional display solutions.",
    items: [
      {
        title: "Trade Show Displays",
        description: "Professional solutions designed for modern business branding.",
      },
      {
        title: "Stand Construction",
        description: "Professional solutions designed for modern business branding.",
      },
      {
        title: "Acrylic Signage",
        description: "Professional solutions designed for modern business branding.",
      },
      {
        title: "Retail Displays",
        description: "Professional solutions designed for modern business branding.",
      },
      {
        title: "Light Boxes",
        description: "Professional solutions designed for modern business branding.",
      },
      {
        title: "Event Branding",
        description: "Professional solutions designed for modern business branding.",
      },
      {
        title: "Printing Solutions",
        description: "Professional solutions designed for modern business branding.",
      },
      {
        title: "Rollups & Display Stands",
        description: "Professional solutions designed for modern business branding.",
      },
    ],
  },
  achievements: {
    subtitle: "Our Achievements",
    title: "Trusted by Businesses Across UAE",
    items: [
      {
        value: "1000",
        suffix: "+",
        label: "Projects Completed",
        iconKey: "projects",
        animate: true,
      },
      {
        value: "500",
        suffix: "+",
        label: "Corporate Clients",
        iconKey: "users",
        animate: true,
      },
      {
        value: "UAE",
        suffix: "",
        label: "Wide Delivery",
        iconKey: "truck",
        animate: false,
      },
    ],
  },
  work: {
    subtitle: "Our Work",
    title: "Creative Project Gallery",
    description: "A showcase of our signage, acrylic, display, and branding works.",
    items: portfolioFallbacks.map((image, index) => ({
      image,
      alt: `SG Sign Graphics Work ${index + 1}`,
    })),
  },
  clients: {
    subtitle: "Clients",
    title: "Trusted By Businesses Across the Region",
    items: [
      { title: "Nandos UAE", image: "" },
      { title: "Dubai Aquarium", image: "" },
      { title: "PepsiCo", image: "" },
      { title: "RAK Bank", image: "" },
      { title: "DIFC", image: "" },
      { title: "VFS Global", image: "" },
      { title: "Hisense Middle East", image: "" },
      { title: "Axiom", image: "" },
    ],
  },
  cta: {
    title: "Need Custom Signage or Fabrication Work?",
    description:
      "Let us help you create professional branding solutions for your next project.",
    buttonText: "Contact Us",
    buttonLink: CONTACT_MAILTO,
  },
};

export function mergeSignSection(sectionKey, apiSection) {
  const fallback = SIGN_FALLBACKS[sectionKey];
  if (!apiSection) return fallback;

  const merged = {
    ...fallback,
    ...apiSection,
  };

  if (sectionKey === "about") {
    merged.paragraphs =
      apiSection.paragraphs?.length > 0
        ? apiSection.paragraphs
        : fallback.paragraphs;
  }

  if (sectionKey === "hero") {
    merged.backgroundImage =
      apiSection.backgroundImage || fallback.backgroundImage;
  }

  if (Array.isArray(apiSection.items)) {
    if (apiSection.items.length === 0 && fallback.items?.length) {
      merged.items = fallback.items;
    } else {
      merged.items = apiSection.items
        .filter((item) => item.isActive !== false)
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
        .map((item, index) => {
          const fb = fallback.items?.[index] || {};
          return {
            ...fb,
            ...item,
            image: item.image || fb.image || "",
          };
        });
    }
  }

  return merged;
}

export function mergeSignContent(apiContent) {
  if (!apiContent) return SIGN_FALLBACKS;
  return {
    hero: mergeSignSection("hero", apiContent.hero),
    about: mergeSignSection("about", apiContent.about),
    services: mergeSignSection("services", apiContent.services),
    achievements: mergeSignSection("achievements", apiContent.achievements),
    work: mergeSignSection("work", apiContent.work),
    clients: mergeSignSection("clients", apiContent.clients),
    cta: mergeSignSection("cta", apiContent.cta),
  };
}
